export const SET_SIDEBAR_OPTIONS = 'SET_SIDEBAR_OPTIONS';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';

export function setSidebarOptions(options) { 
  
  return {
    type: SET_SIDEBAR_OPTIONS,
    payload: options,
  };
}

export function setPermissions(permissions) {
  return {
    type: SET_PERMISSIONS,
    payload: permissions,
  };
}
